// eslint-disable-next-line no-redeclare
import { Box, Group, Skeleton, Space, Text } from '@mantine/core';
import { FC, useContext } from 'react';
import { useElementSize } from '@mantine/hooks';
import ContactListItemDescription from '../Organismns/Contact/ContactListItemDescription';
import ContactProviderHeader from '../Organismns/Contact/ContactProviderHeader';
import 'dayjs/locale/de';
import { EventParticipationsContext } from '../Service/Context/EventParticipationContextV2';
import { DocumentS } from '../Templates/Documents/DocumentS';
import { DocumentContext } from '../Service/Context/DocumentContextV2';
import { Contact } from '../Service/ContactS';
import { openChangeCustomerModal } from './Document/DocumentChangeCustomerModal';
import EInvoiceViolationAlert from './Document/EInvoiceValidationAlert';
import LinkText from '../Atoms/LinkText';

const DocumentHeadData: FC<{ customer: Contact | null }> = ({ customer }) => {
  const { ref, width } = useElementSize();
  const { loading, bookitupDocument, handleChange } = useContext(DocumentContext);
  const eventParticipationsContext = useContext<any>(EventParticipationsContext);

  if (loading) {
    return <Skeleton width="100%" height={200} />;
  }

  if (!bookitupDocument) {
    return null;
  }

  const { originDocumentId, customerId, documentType } = bookitupDocument ?? {};
  const fullVersion = width > 500;

  const openChangeCustomerModalHandler = () => {
    if (bookitupDocument) {
      openChangeCustomerModal({
        documentId: bookitupDocument.id,
        onChange: (newCustomerId) => handleChange({ customerId: newCustomerId }),
        eventParticipationsContext,
        initialCustomerId: bookitupDocument.customerId.toString(),
      });
    }
  };

  return (
    <div ref={ref} style={{ width: '100%' }}>
      {DocumentS.isInvoice(documentType) && <EInvoiceViolationAlert invoice={bookitupDocument} customer={customer} />}
      <Group position="apart" p={fullVersion ? 'xs' : 0}>
        <Box>
          <ContactProviderHeader />
          <Space h="xl" />
          <ContactListItemDescription
            withoutCountry={false}
            withoutPartner
            contactId={customerId}
            addressField
            editingContact={undefined}
            lastModified={undefined}
          />
          {!originDocumentId && (
            <LinkText mt="xs" size="xs" onClick={openChangeCustomerModalHandler}>
              Kunde ändern
            </LinkText>
          )}
        </Box>
      </Group>
    </div>
  );
};

export default DocumentHeadData;
